// src/components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// This component will check if the user is authenticated
const PrivateRoute = ({ element }) => {
  const token = useSelector((state) => state?.authReducer?.tokenData?.token);
  const userRole = useSelector((state) => state?.authReducer?.tokenData?.user?.role);
  
  if (!token) {
    // If the user is not authenticated, redirect them to appropriate login page
    // Redirect fundraisers to their specific login page
    if (userRole && userRole.toLowerCase() === "fundraiser") {
      return <Navigate to="/fundraiser/account-login" />;
    }
    // For all other users or when role is not set, redirect to main login
    return <Navigate to="/" />;
  }
  // If the user is authenticated, return the element
  return element;
};

export default PrivateRoute;